module.exports = "<div class=\"item-container\">\n    <i class=\"fa fa-plus fa-lg new-item-icon\"></i>\n    <article #itemInput placeholder=\"Add new item\" class=\"item\" contenteditable (blur)=\"contentChanged(itemInput.innerText)\" (keydown)=\"onKeyDown($event)\"></article>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/items/NewItem.component.html
// module id = ../../../../../src/app/items/NewItem.component.html
// module chunks = main